<template>
    <info-screen
            class="startRegistration"
            :title="$ml.get('setAdditionalParamsTitle')"
            :text="$ml.get('setAdditionalParamsText')"
            :action="nextScreen"
            :buttonText="$ml.get('additionalParamsNextButton')"
            :titleH1="false"
    >
        <template slot="bottomLink">
            <custom-button
                    class="bottomButton"
                    :button-text="$ml.get('additionalParamsCancelButton')"
                    border
                    :action="cancel"
            ></custom-button>
        </template>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import CustomButton from "../../components/ui/custom-button";
    import Profile from "../../helpers/profile";
    export default {
        name: "infoSetAdditionalParams",
        components: {CustomButton, InfoScreen},
        created() {

        },
        methods: {
            nextScreen: function () {
                if (Profile.needsetphone)
                    this.$router.push(`/${Profile.process}/enterPhonePage`);
                else if (Profile.needsetemail)
                    this.$router.push(`/${Profile.process}/enterEmailPage`);
                else if (Profile.needsetpincode)
                    this.$router.push(`/${Profile.process}/infoPinCode`);
                else if (Profile.needsetquestion)
                    this.$router.push(`/${Profile.process}/infoSecretQuestion`);
            },
            cancel: function () {
                this.$router.push({ name: 'LoginEnterLogin'});
            }
        }
    }
</script>

<style scoped>

</style>